import React from 'react';

import PagesList from './pages-list.jsx';
import ScaleControls from './scale-controls.jsx';

const { $ } = window;

export default class StatusBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: props.project,
      viewport: props.viewport
    };
  }

  componentDidMount() {
    $('[data-content]').popup();
  }

  render() {
    let project = this.state.project;
    let viewport = this.state.viewport;

    return (
      <div id="statusBar">
        <ScaleControls viewport={viewport} />
        <PagesList project={project} />
        {project && (!project.ready || (project.activePage && !project.activePage.ready)) &&
          <div id="processingIcon" className="ui active inline small inverted loader" />
        }
        {project.activePage &&
          <button className="ui mini right floated icon button" data-content="Удалить текущую страницу" onClick={() => project.removePage(project.activePage)}>
            <i className="remove icon" />
          </button>
        }
      </div>
    );
  }
}
